import { defineStore } from 'pinia';

export const accessData = defineStore('access', {
  state: () => ({
    logInPopup: false,
    faPopup: false, // 2 Fact.Auth.Popup
    resetPwdPopup: false,
    decommissionedDevPopup: false,
    activationUserPopup: false,

    sidebarVisibility: true,
  }),
  persist: true

});